<div class="certificate-documents flex flex-col gap-6">
  <p-table data-test="certificate-documents-table"
           scrollHeight="645px"
           scrollable="true"
           stripedRows="true"
           [value]="documents()()"
  >
    <ng-template #header>
      <tr>
        <th id="document-status">Status</th>
        <th id="document-name">Document Name</th>
        <th id="document-publish-date">Publish Date</th>
        <th id="document-effective-date">Effective Date</th>
      </tr>
    </ng-template>
    <ng-template #body
                 let-document
    >
      <tr>
        <td>{{ document.status }}</td>
        <td>{{ document.name }}</td>
        <td>{{ document.publishDate }}</td>
        <td>{{ document.effectiveDate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
